export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "to_setup": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler la demande de mandat"])},
          "description": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["La demande envoyée à ", _interpolate(_named("email")), " sera annulée et le lien d'activation ne sera plus valable."])},
          "confirm_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler la demande"])}
        },
        "active": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler le mandat"])},
          "description": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Le mandat signé par ", _interpolate(_named("email")), " sera annulé : plus aucun prélèvement ne sera possible tant qu'un nouveau mandat n'aura pas été signé."])},
          "confirm_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler le mandat"])}
        },
        "close_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fermer"])}
      },
      "en": {
        "to_setup": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel the mandate request"])},
          "description": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["The request sent to ", _interpolate(_named("email")), " will be cancelled and the activation link will no longer be valid."])},
          "confirm_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel the request"])}
        },
        "active": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel the mandate"])},
          "description": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["The mandate signed by ", _interpolate(_named("email")), " will be cancelled: no more direct debits will be possible until a new mandate is signed."])},
          "confirm_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel the mandate"])}
        },
        "close_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Close"])}
      }
    }
  })
}
